export enum Flags {
  DischargeQuestions = 'discharge_questions',
  ImportImprovements = 'import_improvements',
  AltcsPending = 'altcs_pending',
  Insights = 'insights',
  UmEnhancements = 'um_enhancements',
  ComparisonForAiSummary = 'comparison_for_ai_summary',
  SharedRecords = 'shared_records',
  AdminInPatient = 'admin_in_patient',
  ImportConfigurationChanges = 'import_configuration_changes',
}
